import React, { useState, useEffect } from "react";
import AuthLayout from "../../layouts/AuthLayout";
import {
  Backdrop,
  Box,
  CircularProgress,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { CustomInput } from "../../Components/Common/CustomInput";
import { CustomBtn } from "../../Components/Common/CustomBtn";
import { ErrorSnackbar } from "../../Components/Common/CustomSnackbar";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance, { BASE_URL } from "../../utils/config/config";
import axios from "axios";
import { useDispatch } from "react-redux";
import { getUserById, verifyMfa } from "../../redux/actions/user.dispatcher";

const MfaPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const userId = location.state?.userId;
  const [code, setCode] = useState("");
  const [cooldown, setCooldown] = useState(0);
  const [errorState, setErrorState] = useState({ error: false, message: "" });
  const navigate = useNavigate();
  const smallScreen = useMediaQuery("(max-width:800px)");

  const [loading, setLoading] = useState(false);

  // Start cooldown timer
  useEffect(() => {
    let interval;
    if (cooldown > 0) {
      interval = setInterval(() => {
        setCooldown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [cooldown]);

  const handleVerifyCode = async () => {
    try {
      setLoading(true);
      const login = await verifyMfa(userId, code);

      if (login.user) {
        await dispatch(getUserById(login.user.id));

        navigate("/dashboard");
      } else {
        if (login.status == 400) {
          setLoading(false);
          setErrorState({ error: true, message: login.response.data });
        } else {
          setLoading(false);
          setErrorState({ error: true, message: login.response.data.message });
        }
      }
    } catch (err) {
      setErrorState({ error: true, message: "Invalid or expired code." });
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    try {
      setLoading(true);
      await axios.post(`${BASE_URL}/user/resendMfa`, {
        userId: userId,
      });
      setCooldown(60);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setErrorState({ error: true, message: "Failed to resend code." });
    }
  };

  return (
    <AuthLayout forgotPass>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box>
        <Typography
          sx={{
            fontSize: "22px",
            fontFamily: "Inter-SemiBold",
            color: "#000",
            mb: 4,
          }}
        >
          Enter the 6-digit code sent to your email
        </Typography>

        <CustomInput
          placeholder="Enter MFA Code"
          noIcon
          value={code}
          setValue={setCode}
        />

        <Stack direction="row" sx={{ justifyContent: "center", mt: 2 }}>
          <CustomBtn
            text="Verify Code"
            noIcon
            width={smallScreen ? "75%" : "50%"}
            onClick={handleVerifyCode}
            loading={loading}
          />
        </Stack>

        <Stack direction="row" sx={{ mt: 2, justifyContent: "center" }}>
          <CustomBtn
            text={cooldown > 0 ? `Resend in ${cooldown}s` : "Resend Code"}
            disabled={cooldown > 0}
            onClick={handleResendCode}
            noIcon
            width="auto"
            noMb
            noMt
          />
        </Stack>
      </Box>

      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
    </AuthLayout>
  );
};

export default MfaPage;
